import { SequenceManagerAction } from '../actions/SequenceManagerAction';
import { mobilyOtpSend, mobilyOtpValidate, mobilyOtpResend } from "../api/api";
const OTPVerificationAction = {
    OTP_VERIFICATION_VALUE : 'OTP_VERIFICATION_VALUE',
    VERIFICATION_OTP_INITIATE_SUCCESS : 'VERIFICATION_OTP_INITIATE_SUCCESS',
    VERIFICATION_OTP_VALIDATE_SUCCESS : 'VERIFICATION_OTP_VALIDATE_SUCCESS',
    VERIFICATION_OTP_RSEND_SUCCESS : 'VERIFICATION_OTP_RSEND_SUCCESS',
}


const OTPVerificationValue = (otp: any, offerContainerId: any) => {
    return function (dispatch: any) {
        dispatch({ type: OTPVerificationAction.OTP_VERIFICATION_VALUE, payload: { otp: otp, offerContainerId: offerContainerId } });
        dispatch({ type: SequenceManagerAction.SECTION_COMPLETE, payload: ['OTPVerification'] });
    }
}

const OTPInitiate = (customerId: any, msisdn: any, otpType: any, productLabel: any, technicalName: any, journeyName: any, nationalityCode: any, tccIdType: any, fecEncrypted: any, currentOperator: any, orderMSISDN: any) => {
    return function (dispatch: any) {
        mobilyOtpSend(customerId, msisdn, otpType, productLabel, technicalName, journeyName, nationalityCode, tccIdType, fecEncrypted, currentOperator, orderMSISDN).then((response) => {
            dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_INITIATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                if (error?.response) {
                    dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_INITIATE_SUCCESS, payload: error.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const OTPValidate = (requestId: any, msisdn: any, otp: any, journeyName: any) => {
    return function (dispatch: any) {
        mobilyOtpValidate(requestId, msisdn, otp, journeyName).then((response) => {
            dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_VALIDATE_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_VALIDATE_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

const OTPResend = (orderId: any, requestId: any, journeyName: any) => {
    return function (dispatch: any) {
        mobilyOtpResend(orderId, requestId, journeyName).then((response) => {
            dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_RSEND_SUCCESS, payload: response });
        })
            .catch((error) => {
                //Display error
                if (error?.response) {
                    dispatch({ type: OTPVerificationAction.VERIFICATION_OTP_RSEND_SUCCESS, payload: error?.response });
                } else {
                    dispatch({ type: SequenceManagerAction.GENERIC_ERROR, payload: error });
                }
            })
    }
}

export { OTPVerificationAction, OTPVerificationValue, OTPInitiate, OTPValidate, OTPResend };